import { initializeApp } from "firebase/app";
import { getFirestore, enableMultiTabIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDoT5lV7aQadXEddKu_nQ026rpbngwaFUs",
  authDomain: "tabulare-bb269.firebaseapp.com",
  projectId: "tabulare-bb269",
  storageBucket: "tabulare-bb269.appspot.com",
  messagingSenderId: "1016623848181",
  appId: "1:1016623848181:web:49b8d317fb05ddc19c43bc"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

/** Resolve quando a persistência em IndexedDB estiver pronta (ou falhar de forma segura). Só então o app deve usar o Firestore na primeira carga. */
const firestorePersistenceReady = enableMultiTabIndexedDbPersistence(db).catch((err) => {
  if (err?.code === "failed-precondition") {
    console.warn(
      "Firestore: persistência indisponível (ex.: outra aba já inicializou sem multi-tab)."
    );
  } else if (err?.code === "unimplemented") {
    console.warn("Firestore: persistência não suportada neste navegador.");
  } else {
    console.warn("Firestore: persistência não ativada.", err);
  }
});

const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, firestorePersistenceReady };